import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { layout } from 'styled-system';

import { Box as BaseBox } from '../index';

const Box = styled((props) => <BaseBox {...props} />)`
  position: relative;
  ${layout}
  &::before {
    content: '';
    height: 0;
    display: block;
    padding-bottom: ${({ ratio }) => `calc(100% / ${ratio})`};
  }
  & > * {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  & > img,
  & > video {
    object-fit: cover;
  }
`;

const AspectRatio = ({ ratio, children, ...props }) => {
  return (
    <Box ratio={ratio} {...props}>
      {children}
    </Box>
  );
};

AspectRatio.propTypes = {
  ratio: PropTypes.number,
};

AspectRatio.defaultProps = {
  ratio: 16 / 9,
};

export default AspectRatio;
